(function () {
  var STORAGE_KEY = 'cj_wishlist_v1';

  function readList() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function writeList(list) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (e) {}
  }

  function findIndex(list, productId) {
    for (var i = 0; i < list.length; i++) {
      if (String(list[i].productId) === String(productId)) return i;
    }
    return -1;
  }

  // Account-sync readiness: when a logged-in customer is present (see
  // window.CJWishlistCustomerId, set from Liquid in theme.liquid), a future
  // integration can push/pull this list from a customer metafield via the
  // Storefront API here. No network requests are made today — guest and
  // logged-in shoppers both use localStorage until that's built.
  var CustomerSync = {
    isAvailable: function () {
      return !!window.CJWishlistCustomerId;
    },
    pull: function () {
      return null;
    },
    push: function (list) {}
  };

  var subscribers = [];
  function notify() {
    var list = readList();
    subscribers.forEach(function (fn) {
      fn(list);
    });
    document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { list: list } }));
  }

  var Wishlist = {
    getAll: readList,
    count: function () {
      return readList().length;
    },
    has: function (productId) {
      return findIndex(readList(), productId) !== -1;
    },
    get: function (productId) {
      var list = readList();
      var idx = findIndex(list, productId);
      return idx === -1 ? null : list[idx];
    },
    add: function (entry) {
      var list = readList();
      var idx = findIndex(list, entry.productId);
      if (idx === -1) {
        list.push(entry);
      } else {
        // Same product re-hearted with a different variant selected —
        // update in place rather than creating a duplicate entry.
        list[idx] = Object.assign({}, list[idx], entry);
      }
      writeList(list);
      if (CustomerSync.isAvailable()) CustomerSync.push(list);
      notify();
    },
    remove: function (productId) {
      var list = readList().filter(function (item) {
        return String(item.productId) !== String(productId);
      });
      writeList(list);
      if (CustomerSync.isAvailable()) CustomerSync.push(list);
      notify();
    },
    toggle: function (entry) {
      if (Wishlist.has(entry.productId)) {
        Wishlist.remove(entry.productId);
        return false;
      }
      Wishlist.add(entry);
      return true;
    },
    subscribe: function (fn) {
      subscribers.push(fn);
    }
  };

  window.CJWishlist = Wishlist;

  // ---- Badge + heart state sync ----

  function updateBadge() {
    var count = Wishlist.count();
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  function updateHeartButtons() {
    document.querySelectorAll('[data-wishlist-heart]').forEach(function (btn) {
      var pid = btn.getAttribute('data-wishlist-heart');
      var active = Wishlist.has(pid);
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      btn.setAttribute('aria-label', active ? 'Remove from wishlist' : 'Add to wishlist');
    });
  }

  function entryFromButton(btn) {
    return {
      productId: btn.getAttribute('data-product-id'),
      variantId: btn.getAttribute('data-variant-id'),
      handle: btn.getAttribute('data-product-handle'),
      title: btn.getAttribute('data-product-title'),
      image: btn.getAttribute('data-product-image'),
      price: btn.getAttribute('data-product-price'),
      variantTitle: btn.getAttribute('data-variant-title') || '',
      addedAt: Date.now()
    };
  }

  // Generic path for static contexts (collection/search cards) where the
  // product's data doesn't change on the page — add/remove straight from
  // data attributes on the button.
  document.addEventListener('click', function (evt) {
    var btn = evt.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    evt.preventDefault();
    Wishlist.toggle(entryFromButton(btn));
  });

  Wishlist.subscribe(function () {
    updateBadge();
    updateHeartButtons();
    renderDrawer();
  });

  // ---- Drawer ----

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str == null ? '' : String(str);
    return div.innerHTML;
  }

  function renderDrawer() {
    var list = readList();
    var wrap = document.getElementById('WishlistDrawerItems');
    var emptyEl = document.getElementById('WishlistDrawerEmpty');
    if (!wrap) return;
    wrap.innerHTML = '';
    if (list.length === 0) {
      if (emptyEl) emptyEl.hidden = false;
      wrap.hidden = true;
      return;
    }
    if (emptyEl) emptyEl.hidden = true;
    wrap.hidden = false;
    list.forEach(function (item) {
      var url = item.handle ? '/products/' + item.handle : '#';
      var row = document.createElement('div');
      row.className = 'wishlist-drawer__item';
      row.innerHTML =
        '<a class="wishlist-drawer__image" href="' + url + '">' +
          (item.image ? '<img src="' + escapeHtml(item.image) + '" alt="" loading="lazy">' : '') +
        '</a>' +
        '<div class="wishlist-drawer__item-info">' +
          '<a class="wishlist-drawer__item-title" href="' + url + '">' + escapeHtml(item.title) + '</a>' +
          (item.variantTitle && item.variantTitle !== 'Default Title'
            ? '<p class="wishlist-drawer__item-variant">' + escapeHtml(item.variantTitle) + '</p>'
            : '') +
          '<p class="wishlist-drawer__item-price">' + escapeHtml(item.price) + '</p>' +
          '<div class="wishlist-drawer__item-actions">' +
            '<button type="button" class="wishlist-drawer__item-atc" data-wishlist-atc data-variant-id="' + escapeHtml(item.variantId) + '">Add to Cart</button>' +
            '<button type="button" class="wishlist-drawer__item-remove" data-wishlist-remove data-product-id="' + escapeHtml(item.productId) + '">Remove</button>' +
          '</div>' +
        '</div>';
      wrap.appendChild(row);
    });
  }

  function addToCartFromDrawer(btn) {
    var variantId = Number(btn.getAttribute('data-variant-id'));
    if (!variantId) return;
    btn.disabled = true;
    var original = btn.textContent;
    btn.textContent = 'Adding...';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function (res) {
        return res.json().then(function (data) {
          return { ok: res.ok, data: data };
        });
      })
      .then(function (result) {
        if (!result.ok) throw new Error((result.data && result.data.description) || 'Cart error');
        document.body.dispatchEvent(new CustomEvent('cart:updated', { detail: result.data, bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        btn.textContent = 'Added';
      })
      .catch(function (err) {
        console.error(err);
        btn.textContent = 'Error';
      })
      .finally(function () {
        setTimeout(function () {
          btn.disabled = false;
          btn.textContent = original;
        }, 1200);
      });
  }

  function openDrawer() {
    var drawer = document.getElementById('WishlistDrawer');
    if (!drawer) return;
    renderDrawer();
    drawer.setAttribute('open', '');
    document.body.classList.add('overflow-hidden');
  }

  function closeDrawer() {
    var drawer = document.getElementById('WishlistDrawer');
    if (!drawer) return;
    drawer.removeAttribute('open');
    document.body.classList.remove('overflow-hidden');
  }

  document.addEventListener('click', function (evt) {
    if (evt.target.closest('[data-wishlist-remove]')) {
      Wishlist.remove(evt.target.closest('[data-wishlist-remove]').getAttribute('data-product-id'));
      return;
    }
    if (evt.target.closest('[data-wishlist-atc]')) {
      addToCartFromDrawer(evt.target.closest('[data-wishlist-atc]'));
      return;
    }
    if (evt.target.closest('[data-wishlist-drawer-open]')) {
      evt.preventDefault();
      openDrawer();
      return;
    }
    if (evt.target.closest('[data-wishlist-drawer-close]')) {
      closeDrawer();
      return;
    }
  });

  document.addEventListener('keyup', function (evt) {
    if (evt.key === 'Escape') closeDrawer();
  });

  function init() {
    updateBadge();
    updateHeartButtons();
    renderDrawer();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
